export class DateRange {
    constructor(
        public startDate : Date | null,
        public endDate : Date | null
    ) {}
}